// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CA_OPEN_COST_MODEL,
} from './constants';

export function openCostModel( deliverable,ca, project) {
  return {
    type: CA_OPEN_COST_MODEL,
    caSelected:ca,
    deliverable:deliverable,
    project:project
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CA_OPEN_COST_MODEL:
      return {
        ...state,
        openCostModelDialog:true,
        caSelected:action.caSelected,
        deliverableSelected:action.deliverable,
        project:action.project,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/ca/redux/openCostModel.js